import React from "react";
import SVG from "react-inlinesvg";

import svgs from "./svgs";

const Icon = ({ name, src = null, className }) =>
  (name || src) && <SVG src={src || svgs[name]} {...{ className }} />;

export default Icon;
